import { withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43f364ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "task-list__body card-body rounded-2 p-2" }
const _hoisted_3 = { class: "task-list__body__title card-title d-flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "task-list__title" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "task-list__menu" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-three-dots dropdown-toggle btn-icon",
  role: "button",
  "data-bs-toggle": "dropdown",
  "data-bs-auto-close": "inside"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_9 = {
  key: 0,
  ref: "task-marker",
  class: "d-flex w-100 bg-secondary border-2 px-2 py-4"
}
const _hoisted_10 = {
  key: 1,
  class: "task-list__tasks mb-2"
}
const _hoisted_11 = { class: "task-list__add" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_workspace_list_item = _resolveComponent("workspace-list-item")!
  const _component_workspace_list = _resolveComponent("workspace-list")!
  const _component_workspace_dropdown = _resolveComponent("workspace-dropdown")!
  const _component_kanban_task_card = _resolveComponent("kanban-task-card")!
  const _component_kanban_add_task_form = _resolveComponent("kanban-add-task-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: "task-list card rounded-2 shadow-1 border-0 dropdown",
    id: _ctx.list._id,
    onDragenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDragEnter && _ctx.handleDragEnter(...args))),
    onDragleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDragLeave && _ctx.handleDragLeave(...args))),
    onDragover: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDragOver && _ctx.handleDragOver(...args))),
    onDrop: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args))),
    onDragend: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleDragEnd && _ctx.handleDragEnd(...args)))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("input", {
            type: "text",
            class: "form-control form-control-sm",
            value: _ctx.list.name,
            ref: "listNameInput",
            onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleListNameChange && _ctx.handleListNameChange(...args)), ["enter"]))
          }, null, 40, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_workspace_dropdown, {
            title: "List actions",
            show: _ctx.showListActions,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showListActions = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_workspace_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOptionItems, (item, index) => {
                    return (_openBlock(), _createBlock(_component_workspace_list_item, {
                      key: index,
                      onClick: _ctx.handleDeleteList
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createElementVNode("span", null, _toDisplayString(item.value), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ])
      ]),
      (_ctx.marker)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, null, 512))
        : _createCommentVNode("", true),
      (_ctx.listTasks.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTasks, (task) => {
              return (_openBlock(), _createBlock(_component_kanban_task_card, {
                class: "mb-1",
                key: task._id,
                task: task
              }, null, 8, ["task"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_kanban_add_task_form, {
          listId: _ctx.list._id
        }, null, 8, ["listId"])
      ])
    ])
  ], 40, _hoisted_1))
}